import { Avatar, EllipsisVerticalIcon, Share2Icon } from '@buffer-mono/popcorn'

import {
  getPostDate,
  getCtaText,
} from '~publish/legacy/utils/channels/googlebusiness/helpers'

import { PostWrapper } from '../../../Common/styles'
import type { GoogleBusinessContent, ProfilePreview } from '../../../types'
import { PostBody } from '../PostBody'

import styles from './Post.module.css'

import type { JSX } from 'react'

const verificationBadge =
  'https://buffer-publish.s3.amazonaws.com/images/googlebusiness-verification-badge.svg'

const GoogleBusinessPost = ({
  content,
  profile,
}: {
  content: GoogleBusinessContent
  profile: ProfilePreview
}): JSX.Element => {
  const { avatar, username } = profile
  const { channelData, scheduledAt, updateType } = content
  const googlebusiness = channelData?.googlebusiness

  const isWhatsNew = updateType === 'whats_new'
  const isEvent = updateType === 'event'
  const isOffer = updateType === 'offer'

  const shouldShowOfferLink =
    isOffer && googlebusiness?.link && !googlebusiness?.terms
  const shouldShowTermsAndConditions = isOffer && googlebusiness?.terms
  const shouldShowCtaLink =
    (isWhatsNew || isEvent) && googlebusiness?.cta && googlebusiness?.link

  return (
    <PostWrapper>
      <div className={styles.header}>
        <div className={styles.avatarWrapper}>
          <Avatar
            data-testid="avatar"
            src={avatar}
            alt={username}
            size="small"
          />
          <img
            className={styles.verifiedBadge}
            src={verificationBadge}
            alt="verification badge"
          />
        </div>
        <div className={styles.usernameWrapper}>
          <span className={styles.username} translate="no">
            {username}
          </span>
          <span className={styles.postDate}>{getPostDate(scheduledAt)}</span>
        </div>
        <EllipsisVerticalIcon className={styles.dotsIcon} />
      </div>
      <PostBody content={content} />
      <div className={styles.footer}>
        {shouldShowOfferLink && <div className={styles.cta}>Redeem offer</div>}
        {shouldShowTermsAndConditions && (
          <div className={styles.termsAndConditions}>Terms and Conditions</div>
        )}
        {shouldShowCtaLink && (
          <div className={styles.cta}>{getCtaText(googlebusiness?.cta)}</div>
        )}
        <Share2Icon className={styles.share} />
      </div>
    </PostWrapper>
  )
}

export default GoogleBusinessPost
